import { Fragment, useCallback, useEffect, useState } from "react";
import Table from "components/Table/Table";
import { UNAUTHORIZED } from "constants";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "components/Pagination/Pagination";
import { setNavbarTitle } from "features/navbar/navbarSlice";
import TableSkeleton from "components/Table/TableSkeleton/TableSkeleton";
import { selectAuthUser } from "features/auth/authSlice";
import { actions } from "utils/helpers";
import { toast } from "react-hot-toast";
import {
  useGetLocalizationsQuery,
  useDeleteLocalizationMutation,
} from "features/localization/localizationApiSlice";

import cardStyles from "styles/modules/Card.module.scss";
import styles from "pages/Localizations/Localizations.module.scss";

const Localizations = ({ label }) => {
  const dispatch = useDispatch();

  const authUser = useSelector(selectAuthUser);

  const [searchParams] = useSearchParams();

  const {
    currentData,
    isFetching: isLoading,
    isError,
    error
  } = useGetLocalizationsQuery(searchParams.toString());

  const [deleteLocalization] = useDeleteLocalizationMutation();

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setNavbarTitle("Localizations"));
  }, [dispatch]);

  const [errorDisplayed, setErrorDisplayed] = useState(false);

  useEffect(() => {
    if (isError && !errorDisplayed) {
      toast.error(error?.message || "Could not load localizations, try refreshing the page");
      setErrorDisplayed(true);
    }
  }, [isError, error, errorDisplayed]);


  const onEditBtnHandler = useCallback(
    (id, callFn = false) => {
      if (authUser?.actions[label].includes(actions.view)) {
        if (callFn) {
          navigate(`/localizations/${id}`);
        }

        return "";
      }

      return UNAUTHORIZED;
    },
    [authUser?.actions, label, navigate]
  );

  const onDeleteBtnHandler = useCallback(
    async (id, callFn = false) => {
      if (authUser?.actions[label].includes(actions.delete)) {
        if (callFn) {
          await deleteLocalization(id).unwrap();
        }

        return "";
      }

      return UNAUTHORIZED;
    },
    [authUser?.actions, deleteLocalization, label]
  );

  return (
    <div className={styles.container}>
      <div className={cardStyles.menu}>
        <h3>Showing data for localizations</h3>
      </div>
      {isLoading ? (
        <TableSkeleton />
      ) : (
        <Fragment>
          <Table
            data={currentData}
            onEdit={onEditBtnHandler}
            onDelete={onDeleteBtnHandler}
          />
          <Pagination totalCount={currentData?.size} />
        </Fragment>
      )}
    </div>
  );
};

export default Localizations;
